import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
export function StorySection() {
  return <section className="py-24 bg-white relative" data-id="element-327">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-328">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} className="prose prose-lg md:prose-xl prose-headings:font-serif prose-p:font-sans prose-p:text-ink-800 mx-auto" data-id="element-329">
          <motion.h2 variants={fadeInUp} className="text-3xl md:text-5xl font-bold text-center text-ink-900 mb-12 leading-tight" data-id="element-330">
            "Yo no tengo tiempo para un negocio."
          </motion.h2>

          <motion.p variants={fadeInUp} data-id="element-331">
            Eso fue exactamente lo que <strong data-id="element-332">María</strong> pensó cuando vio
            por primera vez este método.
          </motion.p>

          <motion.p variants={fadeInUp} data-id="element-333">
            Mamá de dos hijos. Trabaja tiempo completo. Su cuenta bancaria
            sangraba cada quincena y Mayo se acercaba con sus gastos extras como
            un tren sin frenos.
          </motion.p>

          <motion.div variants={fadeInUp} className="bg-blush-50 border-l-4 border-emerald-900 p-6 my-10 italic text-ink-900" data-id="element-334">
            <p className="m-0 font-serif text-xl" data-id="element-335">
              Tres semanas después de leer lo que estás a punto de leer...
            </p>
            <ul className="mt-4 space-y-2 font-sans not-italic font-bold text-lg" data-id="element-336">
              <li className="flex items-center" data-id="element-337">
                <span className="text-emerald-900 mr-2" data-id="element-338">✓</span> María vendió 18
                kits de regalo en 6 días.
              </li>
              <li className="flex items-center" data-id="element-339">
                <span className="text-emerald-900 mr-2" data-id="element-340">✓</span> Ganó $486 de
                dinero extra.
              </li>
              <li className="flex items-center" data-id="element-341">
                <span className="text-emerald-900 mr-2" data-id="element-342">✓</span> Y lo hizo en
                las noches, después de acostar a sus hijos.
              </li>
            </ul>
          </motion.div>

          <motion.p variants={fadeInUp} className="text-center font-bold text-2xl mt-12 mb-6" data-id="element-343">
            ¿Cómo?
          </motion.p>

          <motion.p variants={fadeInUp} className="text-center text-xl" data-id="element-344">
            Con un método que convierte{' '}
            <strong data-id="element-345">
              productos de Dollar Tree, 5 Below, Hobby Lobby y Bath & Body Works
            </strong>{' '}
            en regalos que parecen de boutique de $80... y que cuestan menos de
            $15 hacerlos.
          </motion.p>

          {/* Divider */}
          <motion.div variants={fadeInUp} className="flex justify-center py-16" data-id="element-346">
            <div className="w-24 h-px bg-gold-400" data-id="element-347"></div>
            <div className="w-3 h-3 rounded-full bg-gold-500 mx-4 -mt-1.5" data-id="element-348"></div>
            <div className="w-24 h-px bg-gold-400" data-id="element-349"></div>
          </motion.div>

          <motion.h2 variants={fadeInUp} className="text-3xl md:text-4xl font-bold text-center text-ink-900 mb-12" data-id="element-350">
            EL PROBLEMA QUE NADIE TE ESTÁ DICIENDO
          </motion.h2>

          <motion.p variants={fadeInUp} data-id="element-351">
            Cada año, millones de personas buscan desesperadamente el regalo
            perfecto para el Día de la Madre.
          </motion.p>

          <motion.div variants={fadeInUp} className="grid grid-cols-1 md:grid-cols-2 gap-6 my-12 not-prose" data-id="element-352">
            {[{
            icon: '💸',
            text: 'Se gastan más de $35 mil millones de dólares en regalos de Día de la Madre cada año'
          }, {
            icon: '🤷',
            text: 'El 70% de los compradores NO SABE QUÉ REGALAR hasta 5 días antes'
          }, {
            icon: '📦',
            text: 'El 85% prefiere comprar regalos ya armados y empacados'
          }, {
            icon: '🏃',
            text: 'El 60% compra en las últimas 72 horas'
          }].map((stat, idx) => <div key={idx} className="bg-cream-50 p-6 rounded-xl border border-blush-100 shadow-sm flex items-start space-x-4" data-id="element-353">
                <span className="text-3xl" data-id="element-354">{stat.icon}</span>
                <p className="font-medium text-ink-900 leading-snug" data-id="element-355">
                  {stat.text}
                </p>
              </div>)}
          </motion.div>

          <motion.p variants={fadeInUp} className="text-xl font-bold text-center text-emerald-900" data-id="element-356">
            ¿Ves la mina de oro?
          </motion.p>

          <motion.p variants={fadeInUp} className="text-center" data-id="element-357">
            La gente tiene el dinero. La gente tiene la intención. La gente
            tiene el amor.
          </motion.p>

          <motion.p variants={fadeInUp} className="text-center text-2xl font-serif italic text-ink-900 my-8" data-id="element-358">
            Lo que NO tiene es tiempo para pensar, buscar y armar.
          </motion.p>

          <motion.p variants={fadeInUp} className="text-center font-bold text-xl bg-gold-400/20 py-3 px-6 inline-block mx-auto rounded-full" data-id="element-359">
            Tú vas a ser exactamente esa solución.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}